import type * as React from "react";
import { Suspense } from "react";
import { BookingStepOneSkeleton } from "@/components/booking/BookingStepOneSkeleton";
import { BookingStepOne } from "@/components/booking";

const BookingPage: React.FC = () => {
  return (
    <Suspense fallback={<BookingStepOneSkeleton />}>
      <BookingStepOne />
    </Suspense>
  );
};

export default BookingPage;
